import QueryCard from "./querycard";

const QueriesGrid = ({ queries }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
      {queries.map((query) => (
        <QueryCard
          key={query.id}
          {...query}
        />
      ))}
    </div>
  );
};

export default QueriesGrid;
